"use strict";

require("core-js/modules/es.array.includes");

require("core-js/modules/es.string.includes");

var curry = require("./curry.js");

var find = require("./find.js");

var isMatch = require("./isMatch.js");

var go1 = require("./go1.js");

const includes = (v, iter) => {
  if (typeof v === "string" && typeof iter === "string") {
    return iter.includes(v);
  } else {
    return go1(find(isMatch(v), iter), a => a !== undefined);
  }
};

module.exports = curry(includes);